export default "/_next/static/images/ad4-60f4b9d8d4f562d111123d9949115e11.png";